import React, { useEffect, useState } from 'react'
import {useNavigation, useParams} from 'react-router'
import {Item, ItemContent, Segment} from 'semantic-ui-react'
import { useAuth } from '../context/AuthContext'
import { tripApi } from '../misc/TripApi'
import { handleLogError } from '../misc/Helpers'
import {Link} from "react-router-dom";

function BookingPage() {
  const Auth = useAuth()
  const user = Auth.getUser()
  const isUser = user.role === 'USER'
  const {tripId} = useParams()
  const [isTripsLoading, setIsTripsLoading] = useState(false)

  useEffect(() => {
    createUsertrip()
  }, [])

  const createUsertrip = async () => {
    try {
      setIsTripsLoading(true)
      const response = await tripApi.createUsertrip(user, tripId)
    } catch (error) {
      handleLogError(error)
    } finally {
      setIsTripsLoading(false)
    }
  }

  return (
    <Segment loading={isTripsLoading} color='blue'>
      <Item>
        <Item.Content>
          Ваша Заявка на поездку подана. <br/>
          Как только водитель ответит, вам придет уведомление на имейл. <br/>
          Вы сможете связаться с водителем и уточнить детали.<br/>
          Спасибо. <br/>
        </Item.Content>
      </Item>
      <Item>
        <ItemContent><Link to="/">На Главную</Link></ItemContent>
      </Item>
    </Segment>
  )
}

export default BookingPage
